import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import CategoryDetail from './pages/CategoryDetail';
import ChannelAnalysis from './pages/ChannelAnalysis';
import './index.css';

const pageVariants = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
  exit:    { opacity: 0, y: -8,  transition: { duration: 0.2,  ease: 'easeIn'  } },
};

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <motion.div className="page-motion" variants={pageVariants} initial="initial" animate="animate" exit="exit">
            <Dashboard />
          </motion.div>
        } />
        <Route path="/category/:id" element={
          <motion.div className="page-motion" variants={pageVariants} initial="initial" animate="animate" exit="exit">
            <CategoryDetail />
          </motion.div>
        } />
        <Route path="/analyze" element={
          <motion.div className="page-motion" variants={pageVariants} initial="initial" animate="animate" exit="exit">
            <ChannelAnalysis />
          </motion.div>
        } />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  useEffect(() => {
    const cursor = document.getElementById('cursor');
    const ring = document.getElementById('cursor-ring');
    if (!cursor || !ring) return;
    const move = (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      setTimeout(() => {
        ring.style.left = e.clientX + 'px';
        ring.style.top = e.clientY + 'px';
      }, 80);
    };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="grid-bg" />
        <div className="cursor" id="cursor" />
        <div className="cursor-ring" id="cursor-ring" />
        <Navbar />
        <AnimatedRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}
